/** Where the crew app lives in the stores — shared by the header share menu, its QR dialog and the first-run tour. */
export const APP_STORE_LINKS = {
  ios: 'https://apps.apple.com/us/app/ruta-crew/id6749279335',
  android: 'https://play.google.com/store/apps/details?id=com.getruta.mobile',
} as const;
